import React, { useEffect, useState } from "react";
import "../Dashboard/assets/css/app.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faBell, faWallet } from "@fortawesome/free-solid-svg-icons";
import { HOST_URL, NODE_HOST_URL_v1, userProfile } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";

const AdminHeader = () => {
  const lStorage =
    JSON.parse(localStorage.getItem("admin")) ||
    JSON.parse(localStorage.getItem("emp")) ||
    JSON.parse(localStorage.getItem("reseller")) ||
    JSON.parse(localStorage.getItem("client"));
  const Id = lStorage?.user?.userId;
  const name = lStorage?.user?.name;
  const Token = lStorage?.token;
  const type = lStorage?.user?.isAdmin;
  const reseller_type = lStorage?.user?.reseller_type

  const [balance, setBalance] = useState(0)
  const [currency, setCurrency] = useState('')
  const [showRecharge, setShowRecharge] = useState(false)
  // const loginthrough = localStorage.getItem("loginthrough");


  // useEffect(() => {
  //   const verifyUser = {
  //     user_id: Id,
  //     token: Token,
  //     method: "verify",
  //     type: type,
  //   };
  //   fetch(`${HOST_URL}/authentication_data.php`, {
  //     method: "post",
  //     headers: {
  //       "content-Type": "application/json",
  //     },
  //     body: JSON.stringify(verifyUser),
  //   }).then((result) => {
  //     result.json().then((resp) => {
  //       // console.log(resp)
  //       if (resp.success === true) {
  //       } else {
  //         window.location = "/admin/logout";
  //       }
  //     });
  //   });
  // }, []);

  useEffect(() => {
    fetchData();
    fetchPaymentStatus();
  }, []);

  const fetchPaymentStatus = async () => {
    try {
      const payload = {
        user_id: Id,
        token: Token,
        method: "fetchPaymentStatus",
      };
      let { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/reseller_payment_status`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      setShowRecharge(data.success === true);
    } catch (error) {
      setShowRecharge(false);
    }
  };

  const fetchData = async () => {
    try {
      const payload = {
        user_id: Id,
        token: Token,
        method: "retrieve",
      };

      let { data } = await Axios.post(`${HOST_URL}/profile.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (data.success) {
        setCurrency(data.data[0].country_currency);
        setBalance(data.data[0].currency);
        
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };




  // const goBackToAdmin = () => {
  // 	localStorage.removeItem("emp");
  // 	// localStorage.removeItem("loginthrough");
  // 	// localStorage.setItem()
  // 	window.location = "/admin";
  //   };

  return (
    <div style={{ marginTop: "2em" }}>
      <nav className="navbar navbar-expand navbar-light navbar-bg fixed-top">
        <div className="navbar-collapse navbarcollapse_none collapse float-right">
          <ul className="navbar-nav navbar-align ">
            <li
              style={{ position: "relative" }}
              className="nav-item border-right mr-1"
            >
              <Link
                style={{ color: "#3b7ddd" }}
                className="nav-icon mr-4"
                // href={
                //   parent_type !== "reseller" &&
                //   `${
                //     checkUserUrl(url) === true
                //       ? "/dashboard/transaction-payment"
                //       : "/dashboard/transaction-history"
                //   }`
                // }
                to={reseller_type !== "reseller" && "/admin/transaction-payment"}
              >
                <div className="position-relative wallet">
                  <FontAwesomeIcon icon={faWallet} />{" "}
                  <span className="wallet-price">
                    {" "}
                    {currency}
                    {/* : {parseFloat(balance).toFixed(2)} */}
                    : {balance}
                  </span>
                </div>

                {Id !== 27560 && (reseller_type !== "reseller" ? true : showRecharge) &&
                  <span
                    style={{
                      fontSize: 11 + "px",
                      fontWeight: 'bold',
                      color: '#6C757D',
                      position: "absolute",
                      left: 35 + "%",
                    }}
                  >
                    Recharge
                  </span>}
              </Link>
            </li>
            <li className="nav-item border-right">
              <Link
                className="nav-icon"
                to="/admin/admin-notification"
                id="alertsDropdown"
                data-toggle=""
              >
                <div className="position-relative">
                  <FontAwesomeIcon icon={faBell} color="red" />
                  <span className="indicator">1</span>
                </div>
              </Link>
            </li>

            <li className="nav-item border-right">
              <div className="position-relative">
                <p className="mr-3 mb-0 mt-2 ">
                  {" "}
                  <strong> Welcome : {name} </strong>{" "}
                </p>
              </div>
            </li>
            <li className="nav-item">
              <Link className="nav-icon" to="/admin/logout">
                <div className="position-relative">
                  <FontAwesomeIcon icon={faPowerOff} />
                </div>
              </Link>
            </li>

            {/* {loginthrough ? (
            <li className="nav-item dropdown">
              <span
                style={{ cursor: "pointer" }}
                onClick={(e) => goBackToAdmin(e)}
                className="nav-icon"
              >
                <div color="red" className="position-relative">
                  <FontAwesomeIcon color="red" icon={faTimesCircle} />
                </div>
              </span>
            </li>
          ) : null } */}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default AdminHeader;
